import MobileDetect from 'mobile-detect'

const md = new MobileDetect(navigator.userAgent)

// eslint-disable-next-line import/prefer-default-export
export const isMobile = () => md.mobile()
